import { render, staticRenderFns } from "./ReactWrapper.vue?vue&type=template&id=024fba02&"
import script from "./ReactWrapper.vue?vue&type=script&lang=js&"
export * from "./ReactWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports